import { render, staticRenderFns } from "./Remittance.vue?vue&type=template&id=8a08c30c"
import script from "./Remittance.vue?vue&type=script&lang=js"
export * from "./Remittance.vue?vue&type=script&lang=js"
import style0 from "./Remittance.vue?vue&type=style&index=0&id=8a08c30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports